import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserTagDataFragment } from '../../../api';
import useCommonStyles from '../../../useCommonStyles';
import TagDeleteDialog from './TagDeleteDialog';
import TagRow from './TagRow';

export type TagTableProps = {
    tags: UserTagDataFragment[];
    onEdit: (tagId: string) => void;
    onUpdates: () => Promise<void>;
};

const TagTable = ({ tags, onEdit, onUpdates }: TagTableProps) => {
    const { t } = useTranslation(['tagManagementPage']);
    const commonStyles = useCommonStyles();
    const [deleteTag, setDeleteTag] = useState<UserTagDataFragment | null>(null);

    return (
        <Box mb={3}>
            <Table className={commonStyles.table}>
                <TableHead>
                    <TableRow className={commonStyles.tableRow}>
                        <TableCell>{t('tagManagementPage:headers.name')}</TableCell>
                        <TableCell align="left">{t('tagManagementPage:headers.dealerTagged')}</TableCell>

                        <TableCell align="right">
                            <Box
                                sx={{
                                    width: 140,
                                    ml: 'auto',
                                    textAlign: 'center',
                                }}
                            >
                                {t('tagManagementPage:headers.actions')}
                            </Box>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tags.map(tag => (
                        <TagRow
                            key={tag.id}
                            onDelete={() => setDeleteTag(tag)}
                            onEdit={() => onEdit(tag.id)}
                            tag={tag}
                        />
                    ))}
                </TableBody>
            </Table>
            <TagDeleteDialog
                onClose={() => setDeleteTag(null)}
                onDeleted={onUpdates}
                open={!!deleteTag}
                tag={deleteTag}
            />
        </Box>
    );
};

export default TagTable;
